import * as React from 'react';
import { renderEmpty } from '../../common/Render';
import translate from '../../../../locale/translate';

import { IReportSettings, MAV } from '../../../../interfaces';

import EventTable from '../eventCommon/EventTable';
import ISettings from '../eventCommon/ISettings';
import IWidgetProps from './IWidgetProps';

interface IEventsById {
    nodeId?: MAV.IEvent[];
}

interface IProps extends IWidgetProps {
    settings: ISettings;
}

export default class Widget extends React.Component<IProps, {}> {
    static propTypes = {
        events: React.PropTypes.object.isRequired,
        systems: React.PropTypes.array.isRequired,
        settings: React.PropTypes.object.isRequired,
        reportSettings: React.PropTypes.object.isRequired,
    };

    renderEventTables(systems: MAV.ISystem[], events: IEventsById, settings: ISettings, reportSettings: IReportSettings) {
        const byParent = systems.reduce((map, node) => {
            const parentId = node._searchIdx.parentNames.slice(2).join(' / ');

            if (!map[parentId]) {
                map[parentId] = [];
            }

            map[parentId].push(node);

            return map;
        }, {});

        const parents = Object.keys(byParent).sort();

        return parents.map(function (parent) {
            const parentKey = `parent-${parent}`;

            const children = byParent[parent].map((node) => {
                const nodeKey = `node-${node.id}`;
                return (
                    <div key={nodeKey}>
                        <EventTable title={node.name} events={events[node.id]} settings={settings} />
                    </div>
                );
            });

            return (
                <div key={parentKey} className="space-xl">
                    <h4>{parent}</h4>
                    {children}
                </div>
            );
        });
    }

    renderData(systems: MAV.ISystem[], events: IEventsById, settings: ISettings, reportSettings: IReportSettings) {
        systems = systems.sort((a: MAV.ISystem, b: MAV.ISystem) => {
            if (!a.virusInformation) {
                return 1;
            }

            if (a.virusInformation && b.virusInformation) {
                if (a.virusInformation.Count > b.virusInformation.Count) {
                    return -1;
                }

                if (a.virusInformation.Count < b.virusInformation.Count) {
                    return 1;
                }
            }

            return 0;
        });

        return this.renderEventTables(systems, events, settings, reportSettings);
    }

    render() {
        let { systems, events } = this.props;
        const { settings, reportSettings } = this.props;
        let systemsWithAv = 0;

        systems = systems || [];
        events = events || {};

        systems = systems.filter((system: MAV.ISystem) => {
            if (!system.virusInformation) {
                return false;
            }

            systemsWithAv++;

            if (!settings.displaySystemsWithoutEvents && system.virusInformation.Count <= 0) {
                return false;
            }

            return true;
        });

        let renderedData;
        if (systems && systems.length && events) {
            renderedData = this.renderData(systems, events, settings, reportSettings);
        } else if (systemsWithAv > 0) {
            renderedData = renderEmpty(translate.gettext("No threads occured"), translate.gettext("No threads where detected by the scanner and guard"));
        } else {
            renderedData = renderEmpty(translate.gettext("No managed antivirus"), translate.gettext("None of the selected systems uses managed antivirus"));
        }

        return (
            <div>
                {renderedData}
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/widget/mav/listEvents/Widget.tsx